import dialogContentTextClasses from "@mui/material/DialogContentText/dialogContentTextClasses";
import { typographyResponsive } from "../../styles/utils";
export const MuiDialogContentTextTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, typographyResponsive(dt, "h4.medium")), { [`.${dialogContentTextClasses.root} + &`]: {
                    marginTop: dt.stacked.medium,
                } }),
        },
    };
};
